import { BRANDS } from "../../../configs";

const toFieldDestinationsAdapter = (data, labels, classes, brand) => {
	let list = [
		{
			title: labels?.destinations,
			items: []
		}
	];
	let sortedListView = [];
	let baseDestination = {
		label: "",
		value: ""
	};
	// Sort destination groups by order
	const regionOrder = ["SO", "US", "EU", "CA"];
	const regionGroup = [];
	let allDestinations = [];

	if (brand.toLowerCase() === BRANDS.SOV.toLowerCase()) {
		const _baseDestination = data?.destinationGroups?.find(
			destination => destination?.groupName.toLowerCase() === "all countries"
		);

		baseDestination = _baseDestination
			? {
					label: _baseDestination?.groupName,
					value: _baseDestination?.groupCode
			  }
			: baseDestination;

		// eslint-disable-next-line array-callback-return
		data?.destinationGroups?.map(destinationGroup => {
			list?.[0]?.items.push({
				label: destinationGroup.groupName,
				value: destinationGroup.groupCode.replace(/_$/, "")
			});

			if (destinationGroup?.destinations?.length > 1) {
				// eslint-disable-next-line array-callback-return
				destinationGroup?.destinations.map(subDestination => {
					list?.[0]?.items.push({
						prefix: "—",
						label: subDestination?.destName,
						value: subDestination?.destCode
					});
				});
			}
		});
	} else {
		baseDestination = {
			label: data?.BaseDestination?.Name,
			value: data?.BaseDestination?.ProviderCode?.split("_")
				.sort((a, b) => a - b)
				.join("_")
		};

		const sortName = (a, b) => a?.Name.localeCompare(b?.Name);

		// Pre-process to determine region groups and tag priority for sorting
		data?.Regions.forEach(region => {
			const match = regionOrder.findIndex(ro => ro === region.Code);

			if (match > -1) {
				// eslint-disable-next-line no-param-reassign
				region.Priorty = match;

				const code = region?.ProviderCode?.split("_")
					.sort((a, b) => a - b)
					.join("_");

				switch (region.Code.toUpperCase()) {
					case "SO":
						regionGroup.push({
							region: region.Code,
							label: labels.allSouth,
							value: code
						});

						break;

					case "US":
						regionGroup.push({
							region: region.Code,
							label: labels.allUS,
							value: code
						});

						break;

					case "EU":
						regionGroup.push({
							region: region.Code,
							label: labels.allEurope,
							value: code
						});

						break;

					case "CA":
						regionGroup.push({
							region: region.Code,
							label: labels.allCanada,
							value: code
						});

						break;

					default:
				}
			} else {
				// eslint-disable-next-line no-param-reassign
				region.Priorty = 1000;
			}
		});

		data.Regions.sort((a, b) => a?.Priorty - b?.Priorty);

		const allRegions = () => {
			const regionArray = [];

			data?.Regions.forEach(regionItem => {
				// Get Region group for prepending
				const region = regionGroup.find(r => r.region === regionItem.Code);

				// Driven by regionOrder array
				if (region) {
					region.className = classes;
				}

				const countryOrDestination = regionItem.DestinationGroups.map(
					country => {
						const destinationArray = [];

						// Collect all destinations and add a prefix as needed
						country.Destinations.forEach(destination => {
							const showDestination = !destination?.AdditionalInformation?.some(
								info => info?.code === "IsDisplay" && info?.value === "false"
							);

							destinationArray.push({
								prefix: country.Destinations.length > 1 ? "—" : "",
								label: destination.Name,
								value: destination.ProviderCode.replace(/_$/, ""), // trim last char if _
								showDestination,
								typingFilter: `${destination.Name}, ${country.Name}`
							});
						});

						const value = country.ProviderCode;

						let destinationName = "";

						if (destinationArray.length <= 1) {
							destinationName = destinationArray[0].label;
						}

						// Determine if the country name needs to include the single destination to keep alphabetical order
						return {
							label:
								destinationName?.length > 0 &&
								destinationName !== country.Name &&
								destinationArray?.[0]?.showDestination
									? `${country.Name} (${destinationName})`
									: country.Name,
							value,
							destinations: destinationArray
						};
					}
				);

				// Insert region, as needed
				if (region) {
					regionArray.push([region]);
				}

				regionArray.push(countryOrDestination);
			});

			const array = [];

			// Generate typeahead data source
			regionArray.forEach(regionItem =>
				regionItem.forEach(region => {
					array.push(
						region?.className
							? {
									className: region.className,
									label: region.label,
									value: region.value
							  }
							: { label: region.label, value: region.value }
					);

					if (region?.destinations?.length > 1) {
						region.destinations.forEach(destination => {
							if (destination.showDestination) {
								array.push(destination);
							}
						});
					}
				})
			);

			return array;
		};

		allDestinations = [...allDestinations, ...allRegions()];
		allDestinations.unshift(baseDestination);

		list = [
			{
				title: labels.destinations,
				items: allDestinations
			}
		];

		const listView = data?.Regions?.reduce(
			(accumulator, region) => {
				let regionLabel;
				let regionCode;

				switch (region.Code.toUpperCase()) {
					case "SO":
						regionLabel = labels.southernVacations;
						regionCode = region.Code;
						break;
					case "US":
						regionLabel = labels.USAVacations;
						regionCode = "CAUS";
						break;
					case "CA":
						regionLabel = labels.canadaVacations;
						regionCode = "CAUS";
						break;
					case "EU":
						regionLabel = labels.europeanVacations;
						regionCode = region.Code;
						break;
					default:
						// TODO: What if there are multiple unlabeled regions?
						regionLabel = labels.otherVacations;
						regionCode = "OTHER";
				}

				accumulator.regions.push(regionCode);

				if (regionCode === "CAUS") {
					const destinationGroups = [
						...region?.DestinationGroups.map(group => {
							const filteredDestinations = group?.Destinations?.filter(
								destination =>
									!destination?.AdditionalInformation?.some(
										info =>
											info?.code === "IsDisplay" && info?.value === "false"
									)
							);

							if (filteredDestinations.length === 0) {
								return null;
							}

							if (filteredDestinations.length > 1) {
								return { ...group, Destinations: filteredDestinations };
							}

							return {
								Name: filteredDestinations?.[0]?.Name ?? group.Name,
								Code: group.Code,
								ProviderCode: group.ProviderCode
							};
						})
							.filter(x => x)
							.sort(sortName)
					];

					if (accumulator.data[regionCode]?.destinationGroups) {
						accumulator.data[regionCode].label = labels.canadaUSAVacations;

						if (region.Code === "CA") {
							accumulator.data[regionCode].destinationGroups.unshift(
								...destinationGroups
							);
						} else {
							accumulator.data[regionCode].destinationGroups.push(
								...destinationGroups
							);
						}
						accumulator.data[regionCode].popularDestinations = [
							...accumulator.data[regionCode].popularDestinations,
							...region.PopularDestinations
						].sort(sortName);
					} else {
						accumulator.data[regionCode] = {
							label: regionLabel,
							code: regionCode,
							popularDestinations: region.PopularDestinations.sort((a, b) =>
								a.Name.localeCompare(b.Name)
							),
							destinationGroups
						};
					}
				} else {
					accumulator.data[regionCode] = {
						label: regionLabel,
						code: regionCode,
						popularDestinations: region.PopularDestinations.sort((a, b) =>
							a.Name.localeCompare(b.Name)
						),
						destinationGroups: [
							{
								Name: region.Name || labels.allDestinations,
								Code: regionCode,
								ProviderCode: region.ProviderCode
							},
							...region?.DestinationGroups.map(group => {
								const filteredDestinations = group?.Destinations?.filter(
									destination =>
										!destination?.AdditionalInformation?.some(
											info =>
												info?.code === "IsDisplay" && info?.value === "false"
										)
								);

								if (filteredDestinations.length === 0) {
									return null;
								}

								if (filteredDestinations.length > 1) {
									return { ...group, Destinations: filteredDestinations };
								}

								return {
									Name: filteredDestinations?.[0]?.Name ?? group.Name,
									Code: group.Code,
									ProviderCode: group.ProviderCode
								};
							})
								.filter(x => x)
								.sort(sortName)
						]
					};
				}

				return accumulator;
			},
			{ regions: [], data: {} }
		);

		sortedListView = Array.from(
			new Set(["SO", "CAUS", "EU", "OTHER", ...listView.regions])
		)
			.map(regionCode => listView.data[regionCode])
			.filter(x => x);
	}

	return [baseDestination, list, sortedListView];
};

const toFieldHotelsAdapter = (data, groupingLabel) => ({
	title: groupingLabel,
	items:
		data?.hotels
			?.map(hotel => ({
				isHotel: true,
				label: hotel.name,
				value: hotel.code
			}))
			?.sort((a, b) => a.label.localeCompare(b.label)) ?? []
});

export default toFieldDestinationsAdapter;
export { toFieldDestinationsAdapter, toFieldHotelsAdapter };
